<template>
  <div>
    <div class="p-2 bg-secondary-1 rounded">
      <div class="p-3 bg-white rounded">
        <div class="row d-flex align-items-center">
          <div class="col-12 col-md">
            <div class="d-flex">
              <div class="mr-2">
                <i class="fas fa-file-user text-green fs-40" />
              </div>
              <div>
                <div class="data-name">Aceptados:</div>
                <div class="fs-22 lh-1 text-green">
                  {{ value.accepted || '00' }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md">
            <div class="d-flex">
              <div class="mr-2">
                <div
                  class="bg-green rounded-circle d-flex justify-content-center align-items-center dim-40"
                >
                  <i class="fas fa-dollar-sign text-white fa-lg" />
                </div>
              </div>
              <div>
                <div class="data-name">Monto Aceptado:</div>
                <div class="fs-22 lh-1 text-green">
                  {{ (value.acceptedAmount ?? 0) | price }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md">
            <div class="d-flex">
              <div class="mr-2">
                <i class="fas fa-file-user text-warning fs-40" />
              </div>
              <div>
                <div class="data-name">Denegados:</div>
                <div class="fs-22 lh-1 text-warning">
                  {{ value.denied || '00' }}
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-md">
            <div class="d-flex">
              <div class="mr-2">
                <div
                  class="bg-warning rounded-circle d-flex justify-content-center align-items-center dim-40"
                >
                  <i class="fas fa-dollar-sign text-white fa-lg" />
                </div>
              </div>
              <div>
                <div class="data-name">Monto Denegado:</div>
                <div class="fs-22 lh-1 text-warning">
                  {{ (value.deniedAmount ?? 0) | price }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//components
export default {
  name: 'MedicaidClaimBatchRundown',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped>
.dim-40 {
  width: 40px;
  height: 40px;
}
.fs-40 {
  font-size: 40px;
}
.fs-22 {
  font-size: 22px;
}
.lh-1 {
  line-height: 1 !important;
}
.data-name {
  line-height: 1.3 !important;
}

.text-warning {
  color: #f3af54 !important;
}

.bg-warning {
  background-color: #f3af54 !important;
}
</style>
